module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-bingdao.93cc35b6.png";